import React from "react";
import Branches from "../branches/Brnaches";
const BrnchesPage = () => {
  return (
    <div>
      <Branches />
    </div>
  );
};

export default BrnchesPage;
